import { useApiQuery } from 'src/infrastructure/rest-api/useApi';

export const usePipelineStatusQuery = () =>
    useApiQuery('/api/pipelinestatus', 'get', {
        retry: false,
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
    });
